module.exports = __webpack_public_path__ + "img/right-arrow-long-primary.be3a13e3.svg";